// extracted by mini-css-extract-plugin
export default {"root":"style_root__rZwUl","image":"style_image__BYiTr","data":"style_data__86qgj","name":"style_name__Zrt9o"};